<template>
  <div style="margin-top: 50px">
    <div class="edition">
      <ul class="all">
        <li>最新版本</li>
        <li>版本1</li>
        <li>版本2</li>
        <li>版本3</li>
      </ul>
    </div>
    <div class="body">
      <div class="all">
        <div class="basicInformation">
          <div class="title">基本信息</div>
          <ul style="margin-top: 20px;height:500px;width: 100%">
            <li>
              <div>用户名</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>邮箱</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>FirstName</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>LastName</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>中文名</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>身份证</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>出生日期</div>
              <el-date-picker v-model="value1"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>手机</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>地址</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>邮编</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>加入宝马日期</div>
              <el-date-picker v-model="value2"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>在职状态</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>用户类型</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>性别</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>学历</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>所在城市</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>角色</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>职位</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>兼职</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>组</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>加入网点日期</div>
              <el-date-picker v-model="value3"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>离职日期</div>
              <el-date-picker v-model="value4"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>试用期结束日期</div>
              <el-date-picker v-model="value4"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>离开该职位日期</div>
              <el-date-picker v-model="value5"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>加入该职位日期</div>
              <el-date-picker v-model="value6"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>公司/经销商</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>同意收集隐私</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
            <li>
              <div>允许登录</div>
              <select>
                <option>请选择</option>
              </select>
            </li>
          </ul>
          <div class="title">Best信息</div>
          <ul style="height: 80px;width: 100%">
            <li>
              <div>在校时间</div>
              <el-date-picker v-model="value7"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            <li>
              <div>离校时间</div>
              <el-date-picker v-model="value8"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>专业</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>毕业状态</div>
              <input type=""
                     name="">
            </li>
          </ul>
          <div class="title">系统信息</div>
          <ul style="width: 100%;height: 180px;">
            <li>
              <div>创建时间</div>
              <el-date-picker v-model="value9"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>创建者编号</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>更改时间</div>
              <el-date-picker v-model="value10"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </li>
            <li>
              <div>更改者编号</div>
              <input type=""
                     name="">
            </li>
            <li>
              <div>删除状态</div>
              <input type=""
                     name="">
            </li>
          </ul>
        </div>
        <div class="btn">
          <button class="save">保存</button>
          <button class="back"> 返回</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      value1: '',
      value2: '',
      value3: '',
      value4: '',
      value5: '',
      value6: '',
      value7: '',
      value8: '',
      value9: '',
      value10: ''
    }
  }
}
</script>

<style type="text/css" scoped>
input,
select {
  display: block;
  width: 130px;
  height: 35px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
input:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
select:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
li {
  float: left;
  list-style: none;
}
.edition {
  width: 100%;
  height: 50px;
  background-color: #f4f7fa;
  border-bottom: 1px solid #d9e7ec;
  border-top: 1px solid #d9e7ec;
}
.all {
  width: 1200px;
  margin: 0 auto;
}
.edition ul li {
  height: 50px;
  width: 112px;
  line-height: 50px;
  text-align: center;
}
.body {
  width: 100%;
  height: 1000px;
  background-color: #f0f8fa;
  padding-top: 20px;
}
.body .basicInformation .title {
  height: 50px;
  width: 200px;
  border-bottom: 1px solid #5a5dfd;
  line-height: 50px;
  font-weight: bold;
  color: #02a7f0;
  font-size: 16px;
}
.body .basicInformation li {
  margin-top: 10px;
  width: 25%;
  height: 60px;
  padding-right: 25px;
}
.body .basicInformation li div {
  float: left;
  width: 36%;
  text-align: right;
  margin-top: 23px;
}
.body .basicInformation li select,
.body .basicInformation li input {
  float: right;
  margin-top: 10px;
  margin-right: 35px;
}
.btn button {
  width: 100px;
  height: 30px;
  margin-left: 10px;
  background-color: #4ba4dd;
  color: white;
  border: none;
  border-radius: 3px;
}
</style>
<style type="text/css">
.el-input__inner {
  margin-left: 15px;
  margin-top: -10px;
  position: relative;
  width: 130px;
}
.el-icon-date:before {
  position: absolute;
  left: 15px;
  top: -10px;
}
.el-input--prefix .el-input__inner {
  padding-left: 20px;
  padding-right: 10px;
}
.el-input__suffix {
  right: -40px;
  top: -10px;
}
</style>
